(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('ReversalInvoiceModalController', ReversalInvoiceModalController);

    ReversalInvoiceModalController.$inject = ['$uibModalInstance', '$timeout','InvoicesService', 'invoice', 'getInvoices'];

    function ReversalInvoiceModalController($uibModalInstance, $timeout, InvoicesService, invoice, getInvoices) {
        var vm = this;
        vm.invoice                  = invoice;
        vm.getInvoices              = getInvoices;
        vm.invoicesPaymentsList     = [];
        vm.isAllSelected            = false;
        vm.getInvoicePaymentHistory = getInvoicePaymentHistory;
        vm.save                     = save;
        vm.cancel                   = cancel;
        vm.optionToggled            = optionToggled;
        vm.toggleAll                = toggleAll;

        activate();

        function activate() {
            vm.getInvoicePaymentHistory();
        }

        function getInvoicePaymentHistory() {
            if(vm.invoice.id) {
                InvoicesService.getInvoicePaymentHistory(vm.invoice.id).then(function (response) {
                    vm.invoicesPaymentsList = response.data.map(function(item){
                        item.selected = false;
                        return item;
                    });
                }).catch(function (err) {
                });
            }
        }

        function optionToggled() {
            vm.isAllSelected = vm.invoicesPaymentsList.every(function(itm){ return itm.selected; })
        }

        function toggleAll() {
            var toggleStatus = vm.isAllSelected;
            angular.forEach(vm.invoicesPaymentsList, function(itm){ itm.selected = toggleStatus });
        }

        function save() {
            var query = {};
            query.invoices = vm.invoicesPaymentsList.filter(function(item) {
                if(item.selected === true) {
                    return item.id;
                }
            });
            if(query['invoices']){
                InvoicesService.deleteInvoicePayment(query).then(function(response) {
                    vm.getInvoicePaymentHistory();
                }).catch(function(err) {
                });
            }
        }

        function cancel() {
            $uibModalInstance.close();
            vm.getInvoices();
        }
    }

})();